var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pt-0",staticStyle:{"height":"100%"}},[_c('Teleport',{attrs:{"to":"#settings-group-header"}},[_vm._v(" Создание магазина ")]),_c('v-col',{attrs:{"cols":"12"}},[_c('ShopCreate',{attrs:{"corporation":_vm.corporation,"corporations":_vm.corporations.items},on:{"onSubmit":_vm.addShop}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }